import { useEffect, useState } from 'react';
import { useShowContext } from 'framework/show';
import { DashboardEmployee } from '../../types';
import { Typography, Box } from '@mui/material';
import { usePositionService } from 'domain/shared/employee';
import { useTechnologyService } from 'domain/shared/career';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const EmpoyeeDashboardSpecializationField = () => {
  const { data } = useShowContext<DashboardEmployee>();
  const employee = data.getData();
  const { positionId, primaryTechnology, secondaryTechnology, competencyLevel } = employee;
  const { findPositionById } = usePositionService();
  const { findById } = useTechnologyService();
  const [position, setPosition] = useState<Nullable<string>>(null);
  const [technology, setTechnology] = useState<Nullable<string>>(null);

  useEffect(() => {
    (async () => {
      if (positionId) {
        const positionResult = await findPositionById(positionId);
        setPosition(positionResult.name);
      }

      if (primaryTechnology || secondaryTechnology) {
        const technologyResult = await findById(primaryTechnology);
        const secondaryTechnologyResult = await findById(secondaryTechnology);
        setTechnology(
          ` ${technologyResult?.name || secondaryTechnologyResult?.name || ''} ${technologyResult?.name ? secondaryTechnologyResult?.name || '' : ''}`,
        );
      }
    })();
  }, [positionId, findPositionById, findById, primaryTechnology, secondaryTechnology]);

  if (!position && !technology) {
    return <>{EMPTY_VALUE_INDICATOR}</>;
  }

  return (
    <Box display="flex" flexDirection="column">
      <Typography component="span">{position}</Typography>
      <Typography component="span">
        {technology}
        {competencyLevel && ` ${competencyLevel}`}
      </Typography>
    </Box>
  );
};

export default EmpoyeeDashboardSpecializationField;
